import { StopWeather } from '../../components/weather/StopWeather';
import { useWeather } from '../../components/weather/useWeather';

/** The weather on the road: the stop of the day, the day itself first (the `Weather` mockup's
 * Today card). Nothing while it loads or when no stop has the day. */
export function TodayWeather({ trip, day }: { trip: string; day: string }) {
  const state = useWeather(trip);
  if (state.kind !== 'ready') return null;
  const stop = state.weather.stops.find((one) => one.days.some((known) => known.day === day));
  if (!stop) return null;
  return (
    <div className="panel today-weather">
      <StopWeather trip={trip} stop={stop.stop} day={day} />
    </div>
  );
}
